import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { PageTemplateTable } from '../../../../directives/page-template-table/page-template-table';
import { OpeningClosingHoursType, OpeningClosingHoursRequest } from '../../../../models/api-store/opening-closing-hours/opening-closing-hours.request.model';
import { OpeningClosingHoursResponseUpdate } from '../../../../models/api-store/opening-closing-hours/opening-closing-hours.response.model';
import { StoreRequestSearch } from '../../../../models/api-store/store/store.request.model';
import { StoreService } from '../../../../services/api-store/store/store.service';
import { GestioneorariEditComponent } from './gestioneorari-edit/gestioneorari-edit.component';
import { SpinnerService } from '../../../../services/spinner/spinner.service';
import { ChoiceHoursModalComponent } from '../../../../components/ui/choice-hours-modal/choice-hours-modal.component';
import { MassModifyItem } from '../../../../components/ui/mass-modify/mass-modify-item';
import { OpeningClosingHoursService } from '../../../../services/api-store/opening-closing-hours/opening-closing-hours.service';
import { DIALOG_LARGE_CONFIG } from '../../../../utils/config/modal-settings';
import { TRUE } from '../../../../utils/config/const';

@Component({
  selector: 'app-gestioneorari',
  templateUrl: './gestioneorari.component.html',
  styleUrls: ['./gestioneorari.component.css']
})
export class GestioneorariComponent extends PageTemplateTable implements OnInit, OnDestroy, AfterViewInit {

  searchFilterForm: FormGroup;
  searchFilterOther = {
    searchFilterField_dealerCategory: []
  }

  public dealerCategorySettings: any = {}
  public dealerCategoryList: any[];
  public menuSettings: any;
  public menuList: any;
  public selectedMenu: any;
  public isEmpty: boolean = false;
  public isSearching: boolean = false;

  constructor(
    private router: Router,
    private storeService: StoreService,
    private spinner: SpinnerService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public modalService: NgbModal,
    private openingClosingHoursService: OpeningClosingHoursService
  ) {
    super(modalService);
    this.searchFilterForm = this.fb.group({
      searchOldValue: '',
      searchFilterField: ''
    });
  }

  _dealerCategorySettings() {
    return {
      singleSelection: true,
      text: 'Categoria dealer',
      enableCheckAll: false,
      enableFilterSelectAll: false,
      enableSearchFilter: false,
      searchBy: ['value'],
      classes: 'form-control topic-select',
      showCheckbox: false,
      noDataLabel: 'Nessuna risultato con la ricerca associata',
      searchAutofocus: false,
      lazyLoading: false,
      labelKey: 'value',
      primaryKey: 'value',
      maxHeight: 400
    };
  };

  loadDealerCategoryList() {
    this.storeService.findAllDealerCategories().subscribe(
      (response) => {
        this.dealerCategoryList = [];
        for (let obj of response.dealerCategories) {
          this.dealerCategoryList.push({
            value: obj
          });
        }
      });
  }

  /**
   * Inizializza la tabella
   */
  initTable() {
    const that = this;
    this.initCommon_dtOptions();
    this.dtOptions['columnDefs'] = [
      { orderable: false, targets: 0, width: '10%' },
      { orderable: false, targets: 1, width: '15%' },
      { orderable: false, targets: 2, width: '15%' },
      { orderable: false, targets: 3, width: '15%' },
      { orderable: false, targets: 4, width: '15%' },
      { orderable: false, targets: 5, width: '15%' },
      { orderable: false, targets: 6, width: '10%' },
      { orderable: false, targets: 7, width: '10%' }
    ];
    this.dtOptions['ajax'] = (dataTablesParameters: any, callback) => {
      this.isSearching = true;

      if (dataTablesParameters.start > 0) {
        dataTablesParameters.start = dataTablesParameters.start / this.dimPagina;
      }
      that.numeroPagina = dataTablesParameters.start;
      this.dtOptions.pageLength = this.dimPagina;
      let requestSearch = that.getFilter();
      that.storeService.search(requestSearch).subscribe(
        (response) => {
          if (response != null) {
            if (response.data.length == 0) {
              this.isEmpty = true;
            } else {
              this.isEmpty = false;
            }
            that.setListEntityList(response);
            callback({
              recordsTotal: response.total,
              recordsFiltered: response.total,
              data: []
            });
          } else {
            this.isEmpty = false;
            callback({
              recordsTotal: 0,
              recordsFiltered: 0,
              data: []
            });
          }
          that.spinner.hide();
          that.isSearching = false;
        },
        (error: HttpErrorResponse) => {
          console.log(error);
          that.spinner.hide();
          that.isSearching = false;
        }
      );
    }
    this.menuList = this.lengthMenu;
    this.menuSettings = this.settings;
    this.selectedMenu = this.defaultLength;
    this.selectedMenu = [];
    this.selectedMenu.push(this.defaultLength[0]);
  }

  ngOnInit() {

    this.dealerCategorySettings = this._dealerCategorySettings();
    this.loadDealerCategoryList();
    this.initTable();
  }

  ngAfterViewInit() {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }


  /**
   * Click sulla lente per la ricerca
   */
  clickSearch() {
    this.searchFilterForm.controls.searchOldValue.setValue(this.searchFilterForm.controls.searchFilterField.value);
    this.resetFilter();
    this.ajaxReload();
  }

  changeFilter() {
    this.searchFilterForm.controls.searchFilterField.setValue(this.searchFilterForm.controls.searchOldValue.value);
    this.resetFilter();
    this.trigger();
  }

  changeLengthPage(length) {
    let firstPage = 0;
    this.changeLength(length.value, firstPage);
    this.dtOptions.pageLength = this.dimPagina;
    this.trigger();
  }

  removeLength() {
    let firstPage = 0;
    let length = 10;
    this.selectedMenu.push({ 'value': 10 });
    this.changeLength(length, firstPage);
    this.dtOptions.pageLength = this.dimPagina;
    this.resetFilter();
    this.trigger();
  }


  /**
   * Prende i filtri
   * @returns 
   */
  getFilter() {
    let storeRequestSearch = new StoreRequestSearch();
    storeRequestSearch.q = this.searchFilterForm.controls['searchFilterField'].value;
    storeRequestSearch.pageNumber = this.numeroPagina;
    storeRequestSearch.pageSize = this.dimPagina;

    if (this.searchFilterOther.searchFilterField_dealerCategory.length > 0) {
      storeRequestSearch.dealerCategory = this.searchFilterOther.searchFilterField_dealerCategory[0].value;
    }

    storeRequestSearch.visibilityManageOpeningClosingTime = true;
    return storeRequestSearch;
  }

  clickButtonUpdate(id) {
    //Apertura modale di modifica 
    const modalRef = this.modalService.open(GestioneorariEditComponent, { size: 'xl', centered: true });
    modalRef.componentInstance.storeId = id;
    modalRef.componentInstance.type = OpeningClosingHoursType.CUSTOM;
    modalRef.result.then((result: OpeningClosingHoursResponseUpdate) => {
      if (result) {
        this.ajaxReload();
      }
    }, (error) => {
      console.log(error);
    });
  }


  clickButtonClearFilter() {
    this.searchFilterForm.controls.searchFilterField.setValue('');
    this.searchFilterOther.searchFilterField_dealerCategory = [];
    this.clickSearch();
  }

  /* FUNZIONI PER MODIFICHE DI MASSA */
  /**
   * Configura i button del menù modifiche di massa
   */
  public massModifyItems: MassModifyItem[] = [
    {
      title: 'Setta orari custom',
      styleClass: '',
      value: 'SETHOURS',
    },
  ];
  choiceButtonMassModifyResponse(value) {
    let isOk = this.onClickControllItemMassModify();
    if (isOk === TRUE && value == 'SETHOURS') {
      this.onClickButtonItemMassModify_sethours();
    }
  }

  onClickButtonItemMassModify_sethours() {
    //Apre modale selezione 
    const modalRef = this.modalService.open(ChoiceHoursModalComponent, DIALOG_LARGE_CONFIG);
    modalRef.componentInstance.isOnlyView = false;
    modalRef.componentInstance.inputOpeningclosinghoursTable = new OpeningClosingHoursRequest();
    modalRef.result.then(result => {
      if (result) {
        if (result != "CLOSE") {
          let list = this.getListChecked();
          let request = new OpeningClosingHoursRequest();
          request = result;
          let massModifyObj = [];
          for (let obj of list) {
            massModifyObj.push({
              id: obj.id,
              title: obj.titleSeo,
              loading: true,
              call: () => {
                return this.openingClosingHoursService.massiveUpdate(obj.id, request)
              }
            });
          }
          if (list.length > 0) {
            this.openMultiLoadingView(massModifyObj);
          }
        }
      }
    });
  }

}
